// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { Modal } from 'components/atoms/Modal';
import { MasterProduct } from 'util/Types';
import styles from './CreateUpdateMasterProductModal.module.scss';
import { IconClose } from 'components/atoms/icons/IconClose';
import CreateUpdateMasterProductForm from '../CreateUpdateMasterProductForm';

type CreateUpdateMasterProductModalProps = {
  data: Partial<MasterProduct> | undefined;
  onClose?: () => void;
  siteName?: string;
  onUpdateCreateSuccess?: () => void;
};

const CreateUpdateMasterProductModal: React.FC<
  CreateUpdateMasterProductModalProps
> = ({ data, onClose, siteName, onUpdateCreateSuccess }) => {
  if (!data) {
    return null;
  }

  return (
    <div className={styles.CreateUpdateMasterProductModal}>
      <Modal>
        <div className={styles.modalContent}>
          <div className={styles.customTitle}>
            <p className={styles.descriptionTitle}>
              {data.id == null ? '製品を追加' : '製品編集'}
            </p>
            <div className={styles.top}>
              <IconClose onClick={onClose} />
            </div>
          </div>

          <CreateUpdateMasterProductForm
            initialValues={data}
            productId={data.id}
            siteName={siteName}
            onUpdateCreateSuccess={() => {
              onClose?.();
              onUpdateCreateSuccess?.();
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default CreateUpdateMasterProductModal;
